import React from "react";
import { Bar, BarChart, CartesianGrid, Cell, ComposedChart, Legend, Line, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { EaChartCard, EaNote } from "./EaUi";
import { COLORS, fmtQty } from "./eaFormat";

const axis = { tick: { fontSize: 11, fill: "#64748B" }, axisLine: false, tickLine: false };
const t = (v) => [fmtQty(v, 1, "tCO₂")];

export const MIX_COLORS = { self: "#10B981", ppa_onsite: "#6EE7B7", ppa_offsite: "#0EA5E9", go: "#047857", grid: "#CBD5E1" };

export function SusRenewablePie({ row }) {
  const pct = row?.renewable_pct;
  const data = (row?.mix || []).map((m) => ({ name: m.label, value: m.pct, key: m.key }));
  return (
    <EaChartCard title="Energia elettrica rinnovabile vs non coperta" subtitle={`Anno ${row?.year} · mix delle fonti sul totale elettricità`} testid="sus-chart-renewable">
      {pct == null ? <EaNote testid="sus-renewable-missing">Nessuna fonte rinnovabile inserita per l'anno {row?.year}: compila i dati nella scheda "Dati e fattori".</EaNote> : (
        <div className="h-64 relative">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" innerRadius="58%" outerRadius="85%" startAngle={90} endAngle={-270} stroke="none">
                {data.map((d) => <Cell key={d.key} fill={MIX_COLORS[d.key]} />)}
              </Pie>
              <Tooltip formatter={(v, n) => [fmtQty(v, 1, "%"), n]} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex items-center justify-center pb-10 pointer-events-none font-display text-2xl font-bold text-emerald-700" data-testid="sus-pie-center">{fmtQty(pct, 0, "%")}</div>
        </div>
      )}
    </EaChartCard>
  );
}

export function SusPowerGas({ row }) {
  const data = [{ name: "Power", v: row?.co2_power_t, c: COLORS.power }, { name: "Gas", v: row?.co2_gas_t, c: COLORS.gas }];
  return (
    <EaChartCard title="Emissioni Power vs Gas" subtitle={`Anno ${row?.year} · stima in tCO₂`} testid="sus-chart-powergas">
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 10, right: 30 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" />
            <XAxis type="number" {...axis} tickFormatter={(v) => fmtQty(v, 0)} />
            <YAxis type="category" dataKey="name" {...axis} width={60} />
            <Tooltip formatter={t} />
            <Bar dataKey="v" name="Emissioni" radius={[0, 4, 4, 0]} barSize={38}>{data.map((d) => <Cell key={d.name} fill={d.c} />)}</Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </EaChartCard>
  );
}

export function SusTrend({ rows }) {
  const data = rows.map((r) => ({ label: String(r.year), power: r.co2_power_t, gas: r.co2_gas_t, total: r.co2_total_t }));
  return (
    <EaChartCard title="Trend emissioni annuali" subtitle="Emissioni energetiche stimate per anno (tCO₂)" testid="sus-chart-trend">
      {rows.length < 2 && <EaNote>Il trend si completa quando sono disponibili più anni.</EaNote>}
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
            <XAxis dataKey="label" {...axis} />
            <YAxis {...axis} width={70} tickFormatter={(v) => fmtQty(v, 0)} />
            <Tooltip formatter={(v, n) => [fmtQty(v, 1, "tCO₂"), n]} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="power" name="Power" fill={COLORS.power} radius={[3, 3, 0, 0]} />
            <Bar dataKey="gas" name="Gas" fill={COLORS.gas} radius={[3, 3, 0, 0]} />
            <Line dataKey="total" name="Totale" stroke={COLORS.sustain} strokeWidth={2.5} dot={{ r: 4 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </EaChartCard>
  );
}
